import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { authAtom, targetPathAtom } from "../atom";

const PrivateRoute = ({ children }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authState, setAuthState] = useRecoilState(authAtom);
  const [pathName, setPathName] = useRecoilState(targetPathAtom);

  useEffect(() => {
    // Check localStorage
    const auth_token = localStorage.getItem("auth_token");
    const refresh_token = localStorage.getItem("refresh_token");

    // If localStorage is empty redirect to login
    if (!auth_token || !refresh_token) {
      if (
        location.pathname !== "/login" &&
        location.pathname !== "/reset-password"
      ) {
        setPathName(location.pathname);
      }
      if (authState.is_auth) {
        setAuthState({
          is_auth: false,
          auth_token: "",
          refresh_token: "",
        });
      }
      navigate("/login");
      return;
    }

    if (!authState.is_auth && auth_token && refresh_token) {
      setAuthState({
        is_auth: true,
        auth_token: auth_token,
        refresh_token: refresh_token,
      });
      return;
    }

    if (
      !authState.is_auth &&
      location.pathname !== "/login" &&
      location.pathname !== "/reset-password"
    ) {
      setPathName(location.pathname);
      navigate("/login");
    }
  }, [authState, location, navigate, setPathName, setAuthState]);


  return <main>{children}</main>;
};

export default PrivateRoute;
